<template>
  <fieldset
    :class="[
      {[$style.labelModeFieldset]: !inputMode}
    ]"
  >
    <div
      :class="[
        $style.half,
        $style.fieldContainer,
        {[$style.labelModeAlignment]: !inputMode},
        {[$style.labelModeLabelWidth]: !inputMode},
      ]"
    >
      <InputValidator
        v-if="inputMode"
        :config="inputConfig['name']"
        @InputValidatorModel="(index, listItem) => handleInputChange(index, listItem, 'name')"
      />
      <div
        v-else
        :class="{[$style.labelModeLabelText]: !inputMode}"
      >
        {{ inputConfig['name'].value }}
      </div>
    </div>
    <div
      :class="[
        $style.half,
        $style.fieldContainer,
        $style.fieldContainerValue,
        {[$style.labelModeContainerWidth]: !inputMode}
      ]"
    >
      <div
        v-if="isReadOnly(valueReadOnly) || showInput"
        :class="$style.inputValuePosition"
      >
        <InputValidator
          ref="inputValue"
          :config="inputConfig['value']"
          @InputValidatorModel="(index, listItem) => handleInputChange(index, listItem, 'value')"
        />
        <button
          v-if="!isReadOnly(valueReadOnly)"
          :class="[$style.dropDownButton, { [$style.dropDownButtonWithLabel]: !!dropdownLabel }]"
          @click="showDropDownList"
        />
      </div>
      <DropDown
        v-if="!isReadOnly(valueReadOnly) && !showInput"
        ref="dropdown"
        v-validate="valueValidation"
        attribute="value"
        headerText="JumpCloud Attributes"
        :label="dropdownLabel"
        :name="valueAttributeName"
        :options="attributeList"
        :value="listItem.value"
        @input="(index, listItem) => handleInputChange(index, listItem, 'value')"
      />
    </div>
  </fieldset>
</template>
<script>
import { customItem, databaseAttributes } from 'client/util/Constants/ApplicationConstants';
import CustomAttributeFieldsMixin from 'client/components/FormValidation/mixins/CustomAttributeFieldsMixin';
import DropDown from 'client/components/FormValidation/DropDown.vue';
import InputValidator from 'client/components/FormValidation/InputValidator.vue';

export default {
  name: 'DatabaseAttributeFields',

  components: {
    DropDown,
    InputValidator,
  },

  inject: ['$validator'],

  mixins: [CustomAttributeFieldsMixin],

  props: {
    customAttributeList: {
      type: Array,
      default: () => [],
    },
    customNamePlaceholder: {
      type: String,
      default: '',
    },
    customValuePlaceholder: {
      type: String,
      default: '',
    },
    dropdownLabel: {
      type: String,
      default: '',
    },
    inputDisabled: {
      type: Boolean,
      default: false,
    },
    inputLabel: {
      type: String,
      default: '',
    },
    inputMode: {
      type: Boolean,
      default: true,
    },
  },

  data: () => ({
    databaseAttributes,
    showInput: false,
  }),

  computed: {
    attributeList() {
      return (this.useCustomAttributeList ? this.customAttributeList : this.databaseAttributes);
    },
    inputConfig() {
      return {
        name: {
          attribute: 'name',
          disabled: this.inputDisabled,
          label: this.inputLabel,
          name: this.nameAttributeName,
          placeholder: this.customNamePlaceholder || this.namePlaceholder,
          readonly: this.isReadOnly(this.nameReadOnly),
          type: 'text',
          validate: this.nameValidation,
          value: this.listItem.name,
        },
        value: {
          attribute: 'value',
          label: this.dropdownLabel,
          name: this.valueAttributeName,
          placeholder: this.customValuePlaceholder || this.valuePlaceholder,
          readonly: this.isReadOnly(this.valueReadOnly),
          type: 'text',
          validate: this.valueValidation,
          value: this.listItem.value,
        },
      };
    },
    useCustomAttributeList() {
      return (this.customAttributeList.length > 0);
    },
  },

  mounted() {
    this.addCustomItem();
  },

  methods: {
    addCustomItem() {
      if (!this.databaseAttributes.some(attribute => attribute === customItem)) {
        this.databaseAttributes.unshift(customItem);
      }
    },

    handleInputChange(value, key, columnName) {
      let itemValue = value;
      if (columnName === 'value' && value === customItem) {
        this.showInput = true;
        itemValue = '';
        this.$nextTick(() => {
          const inputValue = this.$refs.inputValue.getInputChild();
          inputValue.$refs.input.focus();
        });
      }

      this.handleChangeListItem({
        ...this.listItem, [key]: itemValue,
      }, columnName);
    },

    /**
     * When the "Custom" item from the dropdown gets hit, it switches to
     * text input where the user is able whether to enter a custom value
     * or hit on the dropdown button to display the dropdown instead of
     * the text input.
     */
    async showDropDownList() {
      this.showInput = false;
      await this.$nextTick();

      const bootstrapDropdown = this.$refs.dropdown.$children[0];
      bootstrapDropdown.visible = true;
    },
  },
};
</script>
<style module>
@import '../../css/flex.css';

.dropDownButton {
  background: transparent;
  display: block;
  height: 33px;
  padding-right: 20px;
  position: absolute;
  right: 0;
  top: 0;
}

.dropDownButton::after {
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 6px solid #b3b2b1;
  content: '';
  height: 0;
  left: 17px;
  position: absolute;
  top: 15px;
  width: 0;
}

.dropDownButtonWithLabel {
  top: 22px;
}

.fieldContainer {
  display: inline-block;
  vertical-align: top;
}

.fieldContainerValue input {
  padding-right: 36px;
}

.inputValuePosition {
  position: relative;
}

.labelModeAlignment {
  align-items: center;
  display: flex;
}

.labelModeContainerWidth {
  width: 60%;
}

.labelModeFieldset {
  display: flex;
}

.labelModeLabelText {
  font-weight: bold;
  margin-top: 15px;
}

.labelModeLabelWidth {
  margin-right: 10px;
  width: auto;
}

</style>
